import React, { useState, useEffect, useContext } from "react";
import queryString from "query-string";
import APICall from "../../../services/apiCall";
import { toast } from "react-toastify";
import AppContext from "../../../context/Context";
import Loader from "../../common/Loader";
import LottieAnimation from "../../common/Animation/LottieAnimation";
import CardPaymentSuccessful from "../../common/Animation/card-payment-successful.json";

const TrustCommerceResponsePage = () => {
  const [loading, setLoading] = useState(false);
  const { setRedirectFromPayment, redirectFromPayment, loginUserDetails } = useContext(AppContext);
  // const [storeCardFlag, setStoreCardFlag] = useState(false);

  let search = window.location.search;

  const parsed = queryString.parse(search);
  const customFields = queryString.parse(parsed["transaction[transactioncustomfield]"]);

  let ticket = parsed["transaction[ticket]"];
  let amount = parsed["transaction[amount]"];
  let cardLastFourDigit = parsed["transaction[cc]"];
  let transactionID = parsed["transaction[transid]"];
  let status_name = parsed["transaction[status_name]"];
  let expiryDate = parsed["transaction[exp]"];
  let cardHolderName = parsed["transaction[name]"];
  let cardLogo = parsed["transaction[ccBrand]"];
  let billingID = parsed["transaction[billingId]"];
  let transactioncustomfield = JSON.parse(parsed["transaction[transactioncustomfield]"]);

  useEffect(() => {
    if (status_name === "approved" || status_name === "accepted") {
      setLoading(true);

      let body = {
        dev_id: transactioncustomfield[1],
        billing_id: billingID,
        expiry_date: expiryDate,
        card_last_four_digit: cardLastFourDigit,
        card_logo: cardLogo,
        card_holder_name: cardHolderName,
        transaction_id: transactionID,
        host: transactioncustomfield[2],
        user_name: transactioncustomfield[3],
        user_dev_id:loginUserDetails.dev_id
      };
      APICall.servertrip("POST", "store_card", loginUserDetails, undefined, body).then(
        (res) => {
          setRedirectFromPayment(false);
          setLoading(false);
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
          setLoading(false);
        }
      );
    }
  }, []);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : status_name === "approved" || status_name === "accepted" ? (
        <LottieAnimation
          lotti={CardPaymentSuccessful}
          width={200}
          height={200}
          message="Payment card added successfully"
        />
      ) : (
        // <div>Payment card added successfully.</div>
        <div className="fs-0 mb-2">
          The credit card you provided was declined. Please try with a different card or try again! <br />
        </div>
      )}
    </div>
  );
};

export default TrustCommerceResponsePage;
